const topics = [
  {
    title: "The Magnet World",
    standardNumber: "PS.4.1",
    slug: "themagnetworld",
    description: "Understand how various forces affect the motion of an object.",
    video: "",
    music: "",
    lyrics: [
      
    ],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Charged It Up",
    standardNumber: "PS.4.1",
    slug: "chargeitup",
    description: "Understand how various forces affect the motion of an object.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fchargeitup2025song.mp3?alt=media&token=10a29cc4-9110-436a-8310-e4e5fa2eb7c8",
    lyrics: ["(Chorus)",
"Electric forces, electric forces.",
"Charge it up, charge it up.",
"Electric forces, electric forces.",
"Charge it up, charge it up.",
"Like charges repel, unlike attract,",
"Electric forces make objects act!",
"Charge it up, charge it up.",

"(Verse 1)",
"Rub a balloon, give it a try,",
"Stick it to the wall, watch it fly!",
"Static builds, the charges appear,",
"Electric forces are crystal clear!",
"Lightning strikes, a zap so bright,",
"Electric discharge in the night.",
"Objects can move with a little rub.",
"Charge it up, charge it up.",

"(Chorus)",
"Electric forces, electric forces.",
"Charge it up, charge it up.",
"Electric forces, electric forces.",
"Charge it up, charge it up.",
"Like charges repel, unlike attract,",
"Electric forces make objects act!",
"Charge it up, charge it up.",

"(Verse 2)",
"Test the charges, here’s what to do,",
"See if they pull or push from you.",
"If they repel, the charges are the same,",
"If they attract, opposite’s the name!",
"Test the charges, here’s what to do,",
"See if they pull or push from you.",
"If they repel, the charges are the same,",
"If they attract, opposite’s the name!",

"(Chorus)",
"Electric forces, electric forces.",
"Charge it up, charge it up.",
"Electric forces, electric forces.",
"Charge it up, charge it up.",
"Like charges repel, unlike attract,",
"Electric forces make objects act!",
"Charge it up, charge it up.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
{
    title: "Forms of Energy",
    slug: "formsofenergy",
    standardNumber: "PS.4.2",
    description: "Understand that energy can be transferred from place to place by sound, light, heat, and electric currents.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fformsofenergy2025song.mp3?alt=media&token=5101cfce-2f00-468b-b7c4-89b48eec32cf",
    lyrics: ["(chorus)",
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.", 
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.",

"(verse 1)",
"Chemical energy is stored in gas and coal.", 
"Stored in the bonds of atoms and molecules.", 
"Mechanical energy is stored in things",
"that have tension, like rubber bands and springs.", 
"Nuclear energy is stored in the nucleus of an atom,", 
"it can be released in large amounts.",
"Electrical energy is stored in a battery",
"can start my car or power up my T.V.",

"(chorus)",
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.", 
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.", 

"(verse 2)",
"Electromagnetic energy is radiant energy,", 
"light, x-rays, radio waves.",
"Motion energy is stored in movement.",
"You get more energy the faster it's moving.", 
"Sound energy is energy through waves,", 
"made when a force cause something to vibrate.",

"(chorus)",
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.", 
"Different forms of energy.",
"Potential and kinetic,", 
"potential and kinetic.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Energy Transfer",
    slug: "energytransfer",
    standardNumber: "PS.4.2",
    description: "Understand that energy can be transferred from place to place by sound, light, heat, and electric currents.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fenergytransfer2025video.mp4?alt=media&token=58831dcb-2eb4-4dee-9fee-27e5162a433f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fenergytransfer2025song.mp3?alt=media&token=831ddaef-afbe-4240-ae45-2f6e75dfab3e",
    lyrics: ["(chorus)",
"Let’s transform that energy, transform that energy,",
"transform that energy, transform.",
"Let’s transform that energy, transform that energy,",
"transform that energy, transform.",

"(verse)",
"You can connect solar panels lots of things,",
"and it will change light energy into electrical energy.",
"A T.V. changes electrical energy into light energy,",
"and a T.V. changes electrical energy into sound energy.",
"Let’s see what kind of energy makes a car move.",
"There’s chemical energy inside the fuel,",
"and it turns into thermal and mechanical energy.",
"The batteries in a flashlight have chemical energy.",
"and when it’s turned on, what do you see? You see the light energy.",
"Now, plain old wood has potential chemical energy.",
"Put fire to the wood and it turns into thermal energy for cooking and heat.",

"(chorus)",
"Let’s transform that energy, transform that energy,",
"transform that energy, transform.",
"Let’s transform that energy, transform that energy,",
"transform that energy, transform.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Circuits",
    slug: "circuits",
    standardNumber: "PS.4.2",
    description: "Understand that energy can be transferred from place to place by sound, light, heat, and electric currents.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcircuits2025song.mp3?alt=media&token=8a8e26ab-6a16-4a36-9534-eb2d9133af8b",
    lyrics: ["(chorus)",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",

"(verse)",
"Electricity can only flow through a closed circuit.",
"Electricity cannot flow through an open circuit.",
"Series circuits have only one path",
"for electricity to flow, electricity to flow.",
"Parallel circuits have more than one path",
"for electricity to flow, electricity to flow.",

"(chorus)",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",
"A circuit is the path that electricity takes.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Parallel Circuits",
slug: "parallelcircuits",
    standardNumber: "PS.4.2",
    description: "Understand that energy can be transferred from place to place by sound, light, heat, and electric currents.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fparallelcircuits2025song.mp3?alt=media&token=9a7d3bd6-bee5-410a-9a82-91bfa243e1c0",
    lyrics: ["(chorus)",
"Parallel circuits have more than one resistor.",
"Parallel circuits have more than one resistor.",
"Parallel circuits have more than one resistor.",
"Parallel circuits have more than one resistor.",

"(verse)",
"A parallel circuit is a circuit ",
"with multiple parallel paths.",
"Charges can flow through any of the paths ",
"to keep the flow going.",
"If one of the paths stop because its broken,",
"the other paths will keep on flowing.",

"(chorus)",
"Parallel circuits have more than one resistor.",
"Parallel circuits have more than one resistor.",
"Parallel circuits have more than one resistor.",
"Parallel circuits have more than one resistor.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Conductors & Insulators",
slug: "conductorsandinsulators",
    standardNumber: "PS.4.2",
    description: "Understand that energy can be transferred from place to place by sound, light, heat, and electric currents.",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fconductors2025video.mp4?alt=media&token=575ccfe3-62fb-426b-ad44-5882b54eb356",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fconductors2025song.mp3?alt=media&token=1c1e3505-da36-40da-ae69-d7daa4f17d19",
    lyrics: ["(chorus)",
"Conductors and insulators.",
"Conductors and insulators.",
"Conductors and insulators.",
"Conductors and insulators.",

"(verse 1)",
"What makes materials conduct electricity?",
"When electrons jump.",
"What makes materials conduct electricity?",
"When electrons jump from one atom,",
"into an empty space of another atom.",
"The moving of electrons causes electrical currents.",
"Insulator, a material that electrical charges cannot move through,",
"cannot move through.",
"Conductor, a material that electrical charges easily flow through,",
"flow through.",
"Copper, conductor.",
"Gold, conductor.",
"Rubber, insulator.",
"Styrofoam, insulator.",

"(chorus)",
"Conductors and insulators.",
"Conductors and insulators.",
"Conductors and insulators.",
"Conductors and insulators.",

"© Smart Board Learning, LLC. All rights reserved.",
],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Reflection",
slug: "reflection",

    standardNumber: "PS.4.3",
    description: "Understand the nature of light and how light interacts with objects.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Freflection2025song.mp3?alt=media&token=15279673-9439-4862-8c6e-4e33e4bda158",
    lyrics: ["(chorus)",
"Reflection happens when light bounces,",
"off an object, off an object.",
"Reflection happens when light bounces,",
"off an object, off an object.",

"(verse)",
"You get more reflection from smooth surfaces",
"just like a mirror, just like a mirror.",
"If the surface of the object is rough,",
"then the light scatters, then the light scatters.",

"(chorus)",
"Reflection happens when light bounces,",
"off an object, off an object.",
"Reflection happens when light bounces,",
"off an object, off an object.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Refraction",
slug: "refraction",
    standardNumber: "PS.4.3",
    description: "Understand the nature of light and how light interacts with objects.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Frefraction2025song.mp3?alt=media&token=0ba3b678-a6e0-481c-aca3-44ab676f8fbb",
    lyrics: ["(chorus)",
"Refraction is the bending of light.",
"Refraction is the bending of light.",
"Refraction is the bending of light.",
"Refraction is the bending of light.",

"(verse)",
"When light hits the air it’s moving fast,",
"going on a straight path.",
"But what happens when it hits water?",
"Light slows down and bends on a new path.",
"Now, as light goes back into the air,",
"it speeds up and bends back again.",
"That’s refraction.",
"Refraction is when light bends.",

"(chorus)",
"Refraction is the bending of light.",
"Refraction is the bending of light.",
"Refraction is the bending of light.",
"Refraction is the bending of light.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Adaptation",
slug: "adaptation",
    standardNumber: "LS.4.1",
    description: "Understand the effects of environmental changes, adaptations, and behaviors that enable organisms to survive in changing habitats.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadaptation2025video.mp4?alt=media&token=38306b56-b3b8-4d35-9d62-460a899023b4",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadaptation2025song.mp3?alt=media&token=dc122dec-b0b5-4656-82c2-8e1c2297489b",
    lyrics: ["(Chorus)",
"What is adaptation? The way plants and animals learn to survive.",
"What is adaptation? How they live in their habitat or environment.",
"We adapt, we adapt,",
"To our habitat, to our habitat.",

"(Verse 1)",
"There are some places on Earth that’s very cold or very hot,",
"And still plants and animals live there, they’ve adapted to being there.",
"Some places on Earth have lots of water or lots of rocks,",
"And still plants and animals live there, they’ve adapted to being there.",
"Let’s take a place that doesn’t have much water.",
"Plants and animals both know how to conserve water, store that water.",
"Let’s take a place with high temperatures.",
"Plants move their leaves to minimize surface area hit by the sun.",
"In a place with high temperatures,",
"They both reduce heat output and animals use the shade to avoid the sun.",

"(Chorus)",
"What is adaptation? The way plants and animals learn to survive.",
"What is adaptation? How they live in their habitat or environment.",
"We adapt, we adapt,",
"To our habitat, to our habitat.",

"(Verse 2)",
"Some animals camouflage, change their color or pattern to blend in.",
"Some animals’ mimicry, change their whole look to look like something different.",
"Some plants have needles, to cause pain feelings in animals that touch it.",
"Some plants are poison, to harm an enemy that tries to eat it.",

"(Chorus)",
"What is adaptation? The way plants and animals learn to survive.",
"What is adaptation? How they live in their habitat or environment.",
"We adapt, we adapt,",
"To our habitat, to our habitat.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Adaptive Characteristics",
slug: "adaptivecharacteristics",

    standardNumber: "LS.4.1",
    description: "Understand the effects of environmental changes, adaptations, and behaviors that enable organisms to survive in changing habitats.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadaptivecharacteristics2025video.mp4?alt=media&token=8bef488a-f405-4403-bf1d-b2befa2d032d",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadaptivecharacteristics2025song.mp3?alt=media&token=07c0340b-fe8d-4ae7-8c5b-b4355a19bacd",
    lyrics: ["(chorus)",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",

"(verse)",
"Some animals have webbed feet just like an otter.",
"They can search for food in the water, it makes them swim better.",
"Some animals have sharp claws, like meat eaters,",
"and they use those claws for killing their prey.",
"Some use them for digging for food or shelter, hay.",
"Some animals have large beaks, it helps some animals eat.",
"Some animals have large teeth, it helps the animals eat.",
"Some animals have large beaks, it helps some animals eat.",

"(chorus)",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",

"(verse)",
"Some animals have webbed feet just like an otter.",
"They can search for food in the water, it makes them swim better.",
"Some animals have sharp claws, like meat eaters,",
"and they use those claws for killing their prey.",
"Some use them for digging for food or shelter, hay.",
"Some animals have large beaks, it helps some animals eat.",
"Some animals have large teeth, it helps the animals eat.",
"Some animals have large beaks, it helps some animals eat.",

"(chorus)",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Adapt to Survive",
slug: "adapttosurvive",
    standardNumber: "LS.4.1",
    description: "Understand the effects of environmental changes, adaptations, and behaviors that enable organisms to survive in changing habitats.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadapttosurvivie2025video.mp4?alt=media&token=d7a55d38-6f01-48b5-842d-37634069c361",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadapttosurvive2025song.mp3?alt=media&token=118906ed-f2bd-4a02-ae36-c519e8166ed8",
    lyrics: ["(Chorus)",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"With changes in the world, it’s nature’s way.",
"We adapt to survive, adapt to survive.",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"Some plants and animals have special traits,",
"To adapt to survive, adapt to survive.",

"(Verse 1)",
"A plant with thorns keeps danger away,",
"While other plants get eaten, every day.",
"Camouflage helps an animal hide,",
"Safe from danger, it stays alive.",
"Spots or stripes can blend right in,",
"Hiding from predators, so they can win.",
"In a changing world, traits play a role,",
"Helping animals reach their goal.",

"(Chorus)",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"With changes in the world, it’s nature’s way.",
"We adapt to survive, adapt to survive.",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"Some plants and animals have special traits,",
"To adapt to survive, adapt to survive.",

"(Verse 2)",
"Cause and effect, it’s easy to see,",
"Traits help some live and set them free.",
"Reproducing stronger, they’ll stay alive,",
"Passing on traits, so life will thrive.",
"So watch the world, it’s clear and true,",
"Survival depends on what they do.",
"Traits that help, they carry on,",
"The cycle of life will keep moving strong!",

"(Chorus)",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"With changes in the world, it’s nature’s way.",
"We adapt to survive, adapt to survive.",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"Some plants and animals have special traits,",
"To adapt to survive, adapt to survive.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Good & Bad Changes",
slug: "goodandbadchanges",
    standardNumber: "ESS.4.3",
    description: "Understand changes caused by human impact on the environment.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Fossils",
slug: "fossils",
    standardNumber: "LS.4.2",
    description: "Understand the use of fossils as evidence of the history of Earth and its changing life forms.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Fossils Tell A Story",
slug: "fossilstellastory",
    standardNumber: "LS.4.2",
    description: "Understand the use of fossils as evidence of the history of Earth and its changing life forms.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Fossils From Long Ago",
slug: "fossilsfromlongago",
    standardNumber: "ESS.4.1",
    description: "Understand the use of fossils as evidence of the history of Earth and its changing life forms.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Earth's Rotation",
slug: "earthsrotation",
    standardNumber: "ESS.4.1",
    description: "Understand the causes of day and night and phases of the moon.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fearthsrotation.mp4?alt=media&token=a31d8de2-9598-4afe-bfcb-c3b51a18246c",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fearthsrotation.mp3?alt=media&token=9312642c-9568-452a-8cc8-634c7e5d125f",
    lyrics: ["(chorus)",
"Earth rotates around and around,",
"around and around again.",
"Earth rotates around and around,",
"around and around again.",

"(verse)",
"The Earth spins on its axis,",
"it's turning, it's turning.",
"Makes the sky look like it's moving,",
"it's turning, it's turning.",
"It makes the sun, moon, and stars ",
"look like they’re rising in the east.",
"Then, cross the sky to set in the west, eventually.",
"That's because the Earth is turning, spinning on its axis.",
"It makes a full turn every 24 hours.",
"That is the reason for our day and night, night and day.",
"That is the reason for our day and night, night and day.",

"(chorus)",
"Earth rotates around and around,",
"around and around again.",
"Earth rotates around and around,",
"around and around again.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Earth's Revolution",
slug: "earthsrevolution",
    standardNumber: "ESS.4.1",
    description: "Understand the causes of day and night and phases of the moon.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fearthsrevolution.mp4?alt=media&token=49a38c8b-48fc-4c3c-92ca-463a577121dc",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fearthsrevolution2025song.mp3?alt=media&token=29c46e1a-08f3-4b3c-ac70-d64d55ec2386",
    lyrics: ["(verse)",
"A revolution is one year,",
"365 days is how long it takes",
"for the Earth to go around the Sun.",
"It takes one year, that's a revolution.",

"(chorus)",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution.",

"(verse)",
"A revolution is one year,",
"365 days is how long it takes",
"for the Earth to go around the Sun.",
"It takes one year, that's a revolution.",

"(chorus)",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Moon Phases Rap",
slug: "moonphasesrap",
    standardNumber: "ESS.4.1",
    description: "Understand the causes of day and night and phases of the moon.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmoonphasesrap2025video.mp4?alt=media&token=b2c7a588-ca4a-4103-b790-c9e5b040a867",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmoonphasesrap2025song.mp3?alt=media&token=88173bf0-b997-4602-b9b3-671337ff8cc1",
    lyrics: ["(Chorus)",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"(Verse 1)",
"When the moon is in the same direction of the sun,",
"It’s called the new moon, new moon.",
"When you don’t see no light, coming from the moon,",
"It is a dark moon, called the new moon.",
"A crescent moon is in the next stage,",
"When the moon is lit a quarter of the way.",
"Less than half but more than zero.",
"This is called a crescent moon, true.",
"Now a quarter moon’s a half-moon.",
"You see, a half-moon’s a quarter moon,",
"Quarter moon’s a half-moon.",
"They call a half-moon a quarter moon, word,",
"Because it made a quarter of its turn around the earth.",
"You see half of the moon lit up,",
"And I know what you’re thinking but,",
"It’s a half-moon, called a quarter moon.",
"Half-moon’s a quarter moon,",
"Quarter moon’s a half-moon.",
"(Chorus)",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"(Verse 2)",
"Now, the gibbous moon is a little more full,",
"But not all the way full.",
"The lit-up part is between a full moon,",
"And a half-moon called the gibbous moon.",
"Now the full moon shines so bright.",
"You see the full moon light up the night.",
"Halfway through a circle, circle,",
"You’ll see the full moon light up the night.",
"(Chorus)",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Moon Phases Rock",
slug: "moonphaserock",
    standardNumber: "ESS.4.1",
    description: "Understand the causes of day and night and phases of the moon.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmoonphasesrock2025video.mp4?alt=media&token=25932096-f065-4705-b4e8-859a6ddc48cb",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmoonphasesrock2025song.mp3?alt=media&token=526ab6eb-b5cd-4118-aedf-8ee73536aa1a",
    lyrics: ["(Chorus)",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon, phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon, phases of the moon.",
"(Verse 1)",
"The moon is in the same direction of the sun,",
"It’s a new moon, a new moon, a new moon.",
"When there’s no light coming from the moon,",
"It’s a new moon, a new moon, a new moon.",
"The moon is lit a quarter of the way,",
"It’s a crescent moon, crescent moon, crescent moon.",
"The moon is lit half of the way,",
"It’s a quarter moon, quarter moon, a quarter moon.",
"The moon made a quarter of its turn around the earth,",
"It’s a quarter moon, quarter moon, a quarter moon.",
"(Chorus)",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon, phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon, phases of the moon.",
"(Verse 2)",
"The next phase is between a half and a full moon,",
"Gibbous moon, gibbous moon, third quarter almost full.",
"Now the full moon shines so bright.",
"You see the full moon light up the night.",
"Halfway through a circle you’ll see the full moon",
"Light up the night, light up the night.",
"(Chorus)",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon, phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon, phases of the moon.",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Mineral Properties",
slug: "mineralproperties",
    standardNumber: "ESS.4.2",
    description: "Understand patterns of change in the Earth's surface over time.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "My Three Rocks",
slug: "mythreerocks",
    standardNumber: "ESS.4.2",
    description: "Understand patterns of change in the Earth's surface over time.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmythreerocks2025video.mp4?alt=media&token=0138a21e-1381-437b-b9d1-87552c3cb5cb",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmythreerocks2025song.mp3?alt=media&token=38261703-9b39-477d-977e-e13ce5c01b5a",
    lyrics: ["(chorus)",
"My three rocks.",
"Sedimentary, igneous, and metamorphic.",

"(verse)",
"Sedimentary rocks are formed in layers, formed in layers.",
"Sedimentary rocks are found near water,",
"Some have fossils and found near water.",

"Igneous rocks were here since the beginning.",
"Igneous rocks hot, lava cooled and hardened.",

"When you transform sedimentary and igneous rocks",
"With pressure, they make metamorphic rocks.",
"When you transform sedimentary and igneous rocks",
"With heat, they make metamorphic rocks.",

"(chorus)",
"My three rocks.",
"Sedimentary, igneous, and metamorphic.",
"My three rocks.",
"Sedimentary, igneous, and metamorphic.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Surface Change",
slug: "surfacechange",
    standardNumber: "ESS.4.2",
    description: "Understand patterns of change in the Earth's surface over time.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsurfacechange2025video.mp4?alt=media&token=ac73c746-d5ee-470f-9d84-f04f7a4c0eb8",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsurfacechange2025video.mp4?alt=media&token=ac73c746-d5ee-470f-9d84-f04f7a4c0eb8",
    lyrics: ["(chorus)",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",

"(verse1)",
"Now, what can affect the changes of the earth’s surface?",
"Let’s see, that’s erosion, erosion.",
"When rocks and soil are broken down and wear down the surface,",
"That’s erosion, erosion.",
"Weathering happens when rocks break apart",
"Due to the weather, mechanical and chemical.",
"Weathering happens when rocks break apart",
"Due to the weather, mechanical and chemical.",
"Mechanical weathering happens when rocks break apart",
"Because of flowing water or ice.",
"Mechanical weathering happens when rocks break apart",
"Because it’s too cold or too hot.",
"In chemical weathering, water dissolves the minerals",
"In the rock and the rock breaks apart.",
"In chemical weathering, water dissolves the minerals",
"In the rock and the rock breaks apart.",

"(chorus)",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",

"(verse2)",
"A canyon is a valley between cliffs.",
"There’s often a river flowing through it.",
"The river eroded the layers of rocks",
"And weather caused erosion to occur.",
"Mountains sit high, they’re naturally made",
"When the earth’s crust folds into great waves.",
"From lava, a volcanic mountain is made",
"And erosion gives mountains their shape.",
"It can be an earthquake that changes the shape",
"Of the earth’s surface that starts to shake.",
"It can be a volcano that’s opened up",
"From which lava, gases, and rock erupt.",

"(chorus)",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Weathering",
slug: "weathering",
    standardNumber: "ESS.4.2",
    description: "Understand patterns of change in the Earth's surface over time.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fweathering2025video.mp4?alt=media&token=a9649c8d-b5b6-4180-b9f9-4b1746923164",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fweathering2025song.mp3?alt=media&token=d7242a48-cd46-42b9-8136-1dbab7e492c4",
    lyrics: ["(Chorus)",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",

"(Verse)",
"Weathering is when the rain and wind,",
"Wears away the Earth’s surface.",

"Erosion is when rocks and soil are broken down,",
"And wears down the Earth’s surface.",

"Deposition is when those broken-down rocks and minerals,",
"Are transported to another place.",

"(Chorus)",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Adapting To Our World",
slug: "adaptingtoourworld",
    standardNumber: "ESS.4.3",
    description: "Understand changes caused by human impact on the environment.",
    video: "",
    music: "",
    lyrics: [],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Let’s Find Solutions",
slug: "letsfindsolutions",
    standardNumber: "ESS.4.3",
    description: "Understand changes caused by human impact on the environment.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fletsfindsolutions2025song.mp3?alt=media&token=26088737-9b3e-462a-8f13-a5c64eda41d1",
    lyrics: ["(chorus)",
"Let’s find solutions, we can make a change,",
"let’s find solutions, we can make a change.",
"Help the Earth, it’s up to you and me.",
"Help the Earth for our family!",

"(verse 1)",
"Pollution harms the air and seas,",
"plants and animals, even the trees.",
"Recycling plastic and planting more,",
"can help restore the Earth we adore.",
"Sea turtles need a place to hatch.",
"We give them safety, we’ve got their back.",
"Deforestation harms the land,",
"but planting trees gives us a hand.",

"(chorus)",
"Let’s find solutions, we can make a change,",
"let’s find solutions, we can make a change.",
"Help the Earth, it’s up to you and me.",
"Help the Earth for our family!",

"(verse 2)",
"Littering and waste can cause great harm,",
"but if we act now, we can turn off the alarm.",
"Biodegradable things, reduce and reuse.",
"Simple choices help the Earth renew!",
"Share these ideas with friends and kin.",
"Tell your class where we begin.",
"Together we’ll help the Earth thrive.",
"Solutions will keep our world alive!",

"(chorus)",
"Let’s find solutions, we can make a change,",
"let’s find solutions, we can make a change.",
"Help the Earth, it’s up to you and me.",
"Help the Earth for our family!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },

];
export default topics;
